import styled from "styled-components";
import { PatternBG } from "../../globalStyles";

export const PageContainer = styled.div`
	width: 100%;
	${PatternBG};
`;
